/**
 * Sample passages for typing tests. Original text, non-copyrighted.
 * Different difficulty tiers and topics for category selection.
 *
 * @module typing-engine/passages
 */

/** @typedef {{ text: string, difficulty: 'easy' | 'medium' | 'hard', category: string }} Passage */

/** @type {ReadonlyArray<Passage>} */
export const TEST_PASSAGES = Object.freeze([
  {
    text: 'The quick brown fox jumps over the lazy dog while the morning sun warms the fields.',
    difficulty: 'easy',
    category: 'general',
  },
  {
    text: 'Learning to type well requires patience, steady practice, and a willingness to slow down when accuracy matters more than speed.',
    difficulty: 'easy',
    category: 'learning',
  },
  {
    text: 'A steady rhythm is more valuable than frantic bursts. Focus on the keys in front of you, breathe evenly, and let the words find their pace.',
    difficulty: 'medium',
    category: 'learning',
  },
  {
    text: 'By the time the meeting ended, the team had mapped out three possible approaches, each with its own risks, trade-offs, and realistic timelines.',
    difficulty: 'medium',
    category: 'business',
  },
  {
    text: 'The satellite circled the planet once every ninety minutes, transmitting a narrow signal that took twelve years to reach the nearest listening station.',
    difficulty: 'hard',
    category: 'science',
  },
  {
    text: 'Although the museum had closed an hour earlier, the curator remained at her desk, carefully cataloguing the newly arrived documents before the morning deadline.',
    difficulty: 'hard',
    category: 'general',
  },
]);

/**
 * Returns a deterministic passage for a given index and difficulty.
 * @param {number} index - Picks a passage; the caller rotates this.
 * @param {'easy' | 'medium' | 'hard'} [difficulty]
 * @returns {Passage}
 */
export function pickPassage(index = 0, difficulty) {
  const pool = difficulty
    ? TEST_PASSAGES.filter((p) => p.difficulty === difficulty)
    : TEST_PASSAGES;
  const usable = pool.length > 0 ? pool : TEST_PASSAGES;
  return usable[Math.abs(index) % usable.length];
}